import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  period: {
    '@$': 'focusedRange',
  },
  selection: {
    '{}': {
      name: 'PI Performance',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Density',
                          points: {
                            '@': 'densityQuery',
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'ASF',
                  yLabel: {
                    '++': [
                      {
                        '@$': 'financialVolume',
                      },
                      ' Performance',
                    ],
                  },
                },
              },
            ],
          },
          type: 'scatter',
        },
      },
      overflowActions: {
        '[]': [
          {
            '{}': {
              icon: 'atn-icon atn-link',
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      goto: {
                        '{}': {
                          segmentId: 'pi',
                          navigationId: 'explore',
                        },
                      },
                    },
                  },
                  operation: 'ui.navigate',
                },
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2024',
        },
        start: {
          $date: '1/1/2024',
        },
      },
    },
  },
  subqueries: {
    densityQuery: {
      filter: {
        and: [
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'asfMin',
                  },
                  null,
                ],
              },
              {
                '>=': [
                  {
                    '+': {
                      '@': 'piRoom',
                    },
                  },
                  {
                    '@$': 'asfMin',
                  },
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'asfMax',
                  },
                  null,
                ],
              },
              {
                not: {
                  '>=': [
                    {
                      '+': {
                        '@': 'piRoom',
                      },
                    },
                    {
                      '@$': 'asfMax',
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '{}': {
          x: {
            '+': {
              '@': 'piRoom',
            },
          },
          y: {
            '+': {
              '@': 'piExpense',
            },
          },
          name: {
            '++': [
              {
                '@.': '!name',
              },
              ': ',
              {
                'fmt.num': [
                  {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@>': 'x',
                            },
                            0,
                          ],
                        },
                        0,
                      ],
                      {
                        '/': [
                          {
                            '@>': 'y',
                          },
                          {
                            '@>': 'x',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          onClick: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {
                              piRecordId: {
                                '@.': '!id',
                              },
                              orgEntityId: 'null',
                            },
                          },
                          navigationId: 'explore',
                        },
                      },
                    },
                  },
                  operation: 'ui.navigate',
                },
              },
            },
          },
        },
      },
      subqueries: {
        piRoom: {
          target: 'ent:!personnel:!employee',
          selection: {
            '??': [
              {
                '+': {
                  '@': 'spaces',
                },
              },
              0,
            ],
          },
          subqueries: {
            spaces: {
              ref: {
                attr: 'attr:ent#!person_space#!entry:!space',
              },
              using: 'spaceAssignments',
              filter: {
                if: [
                  [
                    {
                      '@$': 'spaceType',
                    },
                    {
                      in: [
                        {
                          '@.': [
                            '!room_type',
                            {
                              ref: {
                                entity: '!room_type',
                              },
                            },
                          ],
                        },
                        {
                          '@>': [
                            {
                              '`': {
                                '``': {
                                  '@$': 'spaceType',
                                },
                              },
                            },
                            'ent:!room_types:!room_type',
                          ],
                        },
                      ],
                    },
                  ],
                  true,
                ],
              },
              target: 'ent:!space:!room',
              selection: {
                '@.': '!sqft',
              },
            },
            spaceAssignments: {
              ref: {
                attr: 'attr:ent#!person_space#!entry:!personnel',
              },
              target: 'ent:!person_space:!entry',
            },
          },
        },
        piExpense: {
          target: 'ent:!personnel:!employee',
          selection: {
            '+': {
              '@': 'expenses',
            },
          },
          subqueries: {
            projPis: {
              ref: {
                attr: 'attr:ent#!proj_pis#!entry:!pi',
              },
              target: 'ent:!proj_pis:!entry',
            },
            expenses: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              using: 'projects',
              filter: {
                and: [
                  {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'financialVolume',
                            },
                            'MTDC',
                          ],
                        },
                        {
                          '@': 'isInMtdc',
                        },
                      ],
                      true,
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '@$': 'researchType',
                          },
                          null,
                        ],
                      },
                      {
                        in: [
                          {
                            '@': 'researchType',
                          },
                          {
                            '@$': 'researchType',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '@.': '!amount',
              },
              subqueries: {
                project: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  target: 'ent:!projects:!proj',
                },
                isInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!is_in_mtdc',
                  },
                },
                researchType: {
                  ref: {
                    attr: 'attr:ent#!projects#!proj:!award',
                  },
                  using: 'project',
                  target: 'ent:!awards:!award',
                  selection: {
                    '@.': '!research_type',
                  },
                },
              },
            },
            projects: {
              ref: {
                attr: 'attr:ent#!proj_pis#!entry:!proj',
              },
              using: 'projPis',
              target: 'ent:!projects:!proj',
            },
          },
        },
      },
    },
  },
}
